module.exports = __webpack_public_path__ + "static/excel_import_example-6f3d4313ee10dbd50b7fd30dfdca7356.png";